const initialState = {
  fetching: false,
  fetched: false,
  items: [],
  hasMoreItems: false,
  offset: 0,
  limit: 20,
  pelletSelectedOrg: null,
  error: null,
  nbResult: 0,
  cachedState: null
};
export const pelletsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INIT_PELLETS_LIST": {
      return initialState;
    }
    case "RESET_RESOURCES": {
      return { ...initialState };
    }
    case "SET_PELLET_SELECTED_ORG": {
      return {
        ...state,
        pelletSelectedOrg: action.org
      };
    }
    case "RESET_PELLET_SELECTED_ORG": {
      return { ...state, pelletSelectedOrg: null };
    }
    case "FETCH_PELLETS_PENDING": {
      return { ...state, fetched: false, fetching: true, items: [], offset: 0 };
    }
    case "SET_FETCHING": {
      return { ...state, fetching: action.payload };
    }
    case "FETCH_PELLETS_FULFILLED": {
      const { data, nbResult } = action.payload.data;

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data,
        nbResult: nbResult
      };
    }
    case "FETCH_PELLETS_REJECTED": {
      let error = action.payload;

      if (error && error.response && error.response.status) {
        switch (error.response.status) {
          case 404:
            error = {
              title: error.response.data.title,
              code: 404
            };
            break;
          default:
        }
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case "FETCH_INFINITE_PELLETS_PENDING": {
      return { ...state, fetched: false, fetching: true, hasMoreItems: true };
    }
    case "FETCH_INFINITE_PELLETS_FULFILLED": {
      const { data = [], nbResult } = action.payload.data;

      return {
        ...state,
        fetching: false,
        fetched: true,
        hasMoreItems: data.length >= state.limit,
        offset: state.offset + state.limit,
        error: null,
        items: state.items.concat(data),
        nbResult: nbResult
      };
    }
    case "FETCH_INFINITE_PELLETS_REJECTED": {
      let error = action.payload;

      if (error && error.response && error.response.status) {
        switch (error.response.status) {
          case 404:
            error = {
              title: error.response.data.title,
              code: 404
            };
            break;
          default:
        }
      }
      return {
        ...state,
        fetching: false,
        hasMoreItems: false,
        error
      };
    }
    case "SAVE_PELLETS_STATE_TO_CACHE": {
      return {
        ...initialState,
        pelletSelectedOrg: state.pelletSelectedOrg,
        cachedState: {
          ...state
        }
      };
    }
    case "RESTORE_PELLETS_STATE_FROM_CACHE": {
      return {
        ...state.cachedState,
        pelletSelectedOrg: state.pelletSelectedOrg,
        cachedState: null
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/pellet.js